var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageNuevaSolicitud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 168 136",
    style: {
      enableBackground: "new 0 0 168 136"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:#C5CBEF;}\n\t.st2{fill:#DCF1F7;}\n\t.st3{fill:#E2F3F9;}\n\t.st4{fill:#9050FA;}\n\t.st5{fill:#754AC6;}\n\t.st6{fill:#F5F5FD;}\n\t.st7{fill:#92CDF5;}\n\t.st8{fill:#3836BD;}\n\t.st9{fill:#7644C9;}\n\t.st10{fill:#FFD26C;}\n\t.st11{fill:#F2C04F;}\n\t.st12{fill:#FFF8BF;}\n\t.st13{fill:#FFA69B;}\n\t.st14{fill:#585AFA;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.2,
    y: -0.2,
    width: 167.8,
    height: 136.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main_btn_1_",
    transform: "translate(20 104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illust_offset_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-nueva-solicitud_2_",
    transform: "translate(195.027 -40.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_629_2_",
    transform: "translate(24.559 57.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_625_2_",
    transform: "translate(112.889)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_195_2_",
    className: "st1",
    cx: -170.4,
    cy: -95.9,
    r: 8.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_626_2_",
    transform: "translate(0 7.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1686_2_",
    className: "st2",
    d: "M-10.1-40.9C-5.3-24.1-14.7,1.4-36-5.3c-6.1-1.9-11.3-5.8-16.2-9.8 c-6.3-5.2-13.1-11.2-21.3-12.6c-10.9-1.9-22.1,1.2-31.7,6.2c-19.3,10-42.8,42.4-67.9,28.5c-17.5-9.8-18.2-38.7-2.4-50.1 c4.4-3.2,9.4-5.5,13.7-8.9c8.1-6.5,12.2-15.9,13.2-26.2c0.4-4.9,0.3-9.8,2.2-14.3c2.5-6,8-10.3,14.5-11.3 c14.1-1.8,24.4,8.6,34.3,16.8c11.3,9.3,24,14.4,38.5,16.9c17.3,2.9,35.3,4.8,45.4,21C-12.2-46.5-10.9-43.8-10.1-40.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_627_2_",
    transform: "translate(6.639 25.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1687_2_",
    className: "st3",
    d: "M-186.7-80.1c0.2,8.5,10.2,9.2,15.3,4.5c2.9-2.9,4.7-6.7,5.1-10.8 c0.5-4.3,1.1-11.6-1.9-15.2C-176-110.6-186.8-85.7-186.7-80.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_628_2_",
    transform: "translate(132.954 102.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1688_2_",
    className: "st1",
    d: "M-168.2-83.5c13.2-5.9,2.6-21.9-9.1-17.9C-191.3-96.6-182.3-77.3-168.2-83.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_686_2_",
    transform: "translate(62.795 59.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_632_2_",
    transform: "translate(0 19.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_630_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1689_2_",
    className: "st4",
    d: "M-98.5-101.3V11.8c0,1.5-1.2,2.8-2.8,2.8l0,0h-82.8c-1.5,0-2.8-1.2-2.8-2.8l0,0 v-113.1c0-1.5,1.2-2.8,2.8-2.8l0,0h82.8C-99.8-104-98.5-102.8-98.5-101.3L-98.5-101.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_631_2_",
    transform: "translate(0 31.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1690_2_",
    className: "st5",
    d: "M-98.5-104v84.6c0,1.5-1.2,2.8-2.8,2.8l0,0h-82.8c-1.5,0-2.8-1.2-2.8-2.8l0,0 v-38.2L-98.5-104z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_679_2_",
    transform: "translate(7.211 27.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_635_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_633_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1691_2_",
    className: "st6",
    d: "M-126-2.7h-60.8v-101.4h73.9v87.8L-126-2.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_634_2_",
    transform: "translate(60.767 87.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1692_2_",
    className: "st6",
    d: "M-188.7-90.4l14.9-15.4v15.4H-188.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_678_2_",
    transform: "translate(8.131 23.724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_645_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_641_2_",
    transform: "translate(13.557 0.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_636_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1693_2_",
    className: "st7",
    d: "M-163.8-103.3h-22.6c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h22.6 c0.2,0,0.4,0.2,0.4,0.4C-163.4-103.4-163.6-103.3-163.8-103.3L-163.8-103.3L-163.8-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_637_2_",
    transform: "translate(0 6.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1694_2_",
    className: "st7",
    d: "M-178.4-103.3h-8.1c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h8.1 c0.2,0,0.4,0.2,0.4,0.4C-178-103.4-178.2-103.3-178.4-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_638_2_",
    transform: "translate(12.321 6.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1695_2_",
    className: "st7",
    d: "M-167.2-103.3h-19.2c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4l0,0h19.2 c0.2,0,0.4,0.2,0.4,0.4C-166.8-103.4-167-103.3-167.2-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_639_2_",
    transform: "translate(3.318 3.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1696_2_",
    className: "st7",
    d: "M-150-103.3h-36.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4l0,0h36.4 c0.2,0,0.4,0.2,0.4,0.4C-149.6-103.4-149.7-103.3-150-103.3L-150-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_640_2_",
    transform: "translate(29.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1697_2_",
    className: "st7",
    d: "M-170.3-103.3h-16.2c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h16.2 c0.2,0,0.4,0.2,0.4,0.4C-169.9-103.4-170.1-103.3-170.3-103.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_644_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_642_2_",
    transform: "translate(0 0.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1698_2_",
    className: "st8",
    d: "M-177.8-94.6h-8.6c-0.2,0-0.4-0.2-0.4-0.4l0,0v-8.6c0-0.2,0.2-0.4,0.4-0.4 h8.6c0.2,0,0.4,0.2,0.4,0.4l0,0v8.6C-177.4-94.8-177.6-94.6-177.8-94.6L-177.8-94.6z M-186-95.4h7.8v-7.8h-7.8V-95.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_643_2_",
    transform: "translate(2.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1699_2_",
    className: "st9",
    d: "M-184.1-97c-0.2,0-0.4-0.1-0.6-0.2l-1.9-2c-0.3-0.3-0.3-0.8,0-1.1 s0.8-0.3,1.1,0l0,0l1.5,1.5l6.9-5.1c0.3-0.3,0.8-0.3,1.1,0s0.3,0.8,0,1.1l-0.1,0.1l-7.4,5.5 C-183.7-97-183.9-97-184.1-97z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_656_2_",
    transform: "translate(0 13.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_652_2_",
    transform: "translate(13.557 0.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_646_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1700_2_",
    className: "st7",
    d: "M-179.1-103.3h-7.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h7.4 c0.2,0,0.4,0.2,0.4,0.4C-178.7-103.4-178.9-103.3-179.1-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_647_2_",
    transform: "translate(0 6.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1701_2_",
    className: "st7",
    d: "M-181.2-103.3h-5.2c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h5.2 c0.2,0,0.4,0.2,0.4,0.4C-180.9-103.4-181-103.3-181.2-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_648_2_",
    transform: "translate(12.321 6.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1702_2_",
    className: "st7",
    d: "M-163-103.3h-23.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4l0,0h23.4 c0.2,0,0.4,0.2,0.4,0.4C-162.6-103.4-162.8-103.3-163-103.3L-163-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_649_2_",
    transform: "translate(3.318 3.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1703_2_",
    className: "st7",
    d: "M-172.8-103.3h-13.7c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4l0,0h13.7 c0.2,0,0.4,0.2,0.4,0.4C-172.3-103.4-172.5-103.3-172.8-103.3C-172.7-103.3-172.8-103.3-172.8-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_650_2_",
    transform: "translate(20.585 3.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1704_2_",
    className: "st7",
    d: "M-162.5-103.3h-23.9c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h23.9 c0.2,0,0.4,0.2,0.4,0.4C-162.1-103.4-162.3-103.3-162.5-103.3L-162.5-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_651_2_",
    transform: "translate(12.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1705_2_",
    className: "st7",
    d: "M-172.4-103.3h-14c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4l0,0h14 c0.2,0,0.4,0.2,0.4,0.4C-172-103.4-172.2-103.3-172.4-103.3L-172.4-103.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_655_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_653_2_",
    transform: "translate(0 0.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1706_2_",
    className: "st8",
    d: "M-177.8-94.6h-8.6c-0.2,0-0.4-0.2-0.4-0.4v-8.6c0-0.2,0.2-0.4,0.4-0.4h8.6 c0.2,0,0.4,0.2,0.4,0.4l0,0v8.6C-177.4-94.8-177.6-94.6-177.8-94.6z M-186-95.4h7.8v-7.8h-7.8V-95.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_654_2_",
    transform: "translate(2.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1707_2_",
    className: "st9",
    d: "M-184.1-97c-0.2,0-0.4-0.1-0.6-0.2l-1.9-2c-0.3-0.3-0.3-0.8,0-1.1 s0.8-0.3,1.1,0l0,0l1.5,1.5l6.9-5.1c0.3-0.3,0.8-0.3,1.1,0s0.3,0.8,0,1.1l-0.1,0.1l-7.4,5.5 C-183.7-97-183.9-97-184.1-97z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_667_2_",
    transform: "translate(0 26.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_663_2_",
    transform: "translate(13.557 1.985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_657_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1708_2_",
    className: "st7",
    d: "M-174.1-103.3h-12.3c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h12.3 c0.2,0,0.4,0.2,0.4,0.4C-173.7-103.4-173.9-103.3-174.1-103.3L-174.1-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_658_2_",
    transform: "translate(0 6.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1709_2_",
    className: "st7",
    d: "M-163.2-103.3h-23.2c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h23.2 c0.2,0,0.4,0.2,0.4,0.4C-162.8-103.4-163-103.3-163.2-103.3L-163.2-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_659_2_",
    transform: "translate(29.332 6.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1710_2_",
    className: "st7",
    d: "M-174-103.3h-12.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h12.4 c0.2,0,0.4,0.2,0.4,0.4C-173.6-103.4-173.8-103.3-174-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_660_2_",
    transform: "translate(3.318 3.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1711_2_",
    className: "st7",
    d: "M-170.9-103.2h-15.6c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4l0,0h15.6 c0.2,0,0.4,0.2,0.4,0.4C-170.5-103.4-170.7-103.3-170.9-103.2L-170.9-103.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_661_2_",
    transform: "translate(26.318 3.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1712_2_",
    className: "st7",
    d: "M-173.3-103.2h-13.1c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h13.1 c0.2,0,0.4,0.2,0.4,0.4S-173.1-103.3-173.3-103.2L-173.3-103.2L-173.3-103.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_662_2_",
    transform: "translate(16.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1713_2_",
    className: "st7",
    d: "M-157.7-103.3h-28.7c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h28.7 c0.2,0,0.4,0.2,0.4,0.4C-157.4-103.4-157.5-103.3-157.7-103.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_666_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_664_2_",
    transform: "translate(0 0.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1714_2_",
    className: "st8",
    d: "M-177.8-94.6h-8.6c-0.2,0-0.4-0.2-0.4-0.4v-8.6c0-0.2,0.2-0.4,0.4-0.4h8.6 c0.2,0,0.4,0.2,0.4,0.4l0,0v8.6C-177.4-94.8-177.6-94.6-177.8-94.6L-177.8-94.6z M-186-95.4h7.8v-7.8h-7.8V-95.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_665_2_",
    transform: "translate(2.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1715_2_",
    className: "st9",
    d: "M-184.1-97c-0.2,0-0.4-0.1-0.6-0.2l-1.9-2c-0.3-0.3-0.4-0.8-0.1-1.1 c0.3-0.3,0.8-0.4,1.1-0.1l0.1,0.1l1.5,1.5l6.9-5c0.4-0.3,0.9-0.2,1.1,0.2c0.3,0.4,0.2,0.9-0.2,1.1l-7.4,5.5 C-183.7-97-183.9-97-184.1-97z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_677_2_",
    transform: "translate(0 39.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_673_2_",
    transform: "translate(13.557 3.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_668_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1716_2_",
    className: "st7",
    d: "M-163.8-103.2h-22.6c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h22.6 c0.2,0,0.4,0.2,0.4,0.4S-163.6-103.3-163.8-103.2L-163.8-103.2L-163.8-103.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_669_2_",
    transform: "translate(0 6.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1717_2_",
    className: "st7",
    d: "M-178.4-103.3h-8.1c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h8.1 c0.2,0,0.4,0.2,0.4,0.4C-178-103.4-178.1-103.3-178.4-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_670_2_",
    transform: "translate(12.321 6.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1718_2_",
    className: "st7",
    d: "M-167.2-103.3h-19.2c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4l0,0h19.2 c0.2,0,0.4,0.2,0.4,0.4C-166.8-103.4-167-103.3-167.2-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_671_2_",
    transform: "translate(3.318 3.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1719_2_",
    className: "st7",
    d: "M-150-103.3h-36.4c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4l0,0h36.4 c0.2,0,0.4,0.2,0.4,0.4S-149.7-103.3-150-103.3L-150-103.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_672_2_",
    transform: "translate(29.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1720_2_",
    className: "st7",
    d: "M-170.3-103.2h-16.2c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4l0,0h16.2 c0.2,0,0.4,0.2,0.4,0.4C-169.8-103.4-170-103.3-170.3-103.2C-170.2-103.2-170.2-103.2-170.3-103.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_676_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_674_2_",
    transform: "translate(0 0.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1721_2_",
    className: "st8",
    d: "M-177.8-94.6h-8.6c-0.2,0-0.4-0.2-0.4-0.4v-8.6c0-0.2,0.2-0.4,0.4-0.4h8.6 c0.2,0,0.4,0.2,0.4,0.4l0,0v8.6C-177.4-94.8-177.6-94.6-177.8-94.6L-177.8-94.6z M-186-95.4h7.8v-7.8h-7.8V-95.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_675_2_",
    transform: "translate(2.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1722_2_",
    className: "st9",
    d: "M-184.1-97c-0.2,0-0.4-0.1-0.6-0.2l-1.9-2c-0.3-0.4-0.2-0.9,0.2-1.1 c0.3-0.2,0.7-0.2,1,0l1.5,1.5l6.9-5c0.3-0.3,0.8-0.3,1.1,0s0.3,0.8,0,1.1l-0.1,0.1l-7.4,5.5 C-183.7-97-183.9-97-184.1-97z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_685_2_",
    transform: "translate(17.383 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_680_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1723_2_",
    className: "st10",
    d: "M-136.1-88.3L-136.1-88.3h-10.7c-1.6,0-2.9-1.3-3-2.9c0-0.2,0-0.3,0-0.5 c1-5.7-2.9-11.2-8.6-12.2c-0.5-0.1-1.1-0.1-1.6-0.2c-5.8-0.1-10.6,4.6-10.7,10.4v0.1c0,0.5,0,1,0.1,1.5 c0.2,1.8-1,3.4-2.8,3.6c-0.1,0-0.3,0-0.5,0h-10.3l0,0c-1.6,0-2.9,1.3-2.9,2.9v8.8c0,1.1,0.6,2.1,1.6,2.6 c0.4,0.2,0.8,0.3,1.3,0.3l0,0h47.8l0,0c1.6,0,2.9-1.3,2.9-2.9v-8.8C-133.3-87-134.6-88.3-136.1-88.3z M-160.1-99.2 c3.2,0,5.7,2.6,5.7,5.7c0,3.2-2.6,5.7-5.7,5.7c-3.2,0-5.7-2.6-5.7-5.7C-165.8-96.7-163.2-99.2-160.1-99.2L-160.1-99.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_681_2_",
    transform: "translate(1.586 15.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1724_2_",
    className: "st11",
    d: "M-134.9-101.1v8.8c0,1.6-1.3,2.9-2.9,2.9l0,0h-47.8l0,0c-0.4,0-0.9-0.1-1.3-0.3 l41.1-14.3h8l0,0C-136.1-104-134.9-102.7-134.9-101.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_733_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_682_2_",
    transform: "translate(3.062 18.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1725_2_",
    className: "st12",
    d: "M-139.8-103.2h-46.6c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h46.6 c0.2,0,0.4,0.2,0.4,0.4S-139.6-103.2-139.8-103.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_683_2_",
    transform: "translate(3.062 20.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1726_2_",
    className: "st12",
    d: "M-139.8-103.2h-46.6c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h46.6 c0.2,0,0.4,0.2,0.4,0.4S-139.6-103.2-139.8-103.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_684_2_",
    transform: "translate(3.062 23.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1727_2_",
    className: "st12",
    d: "M-139.8-103.2h-46.6c-0.2,0-0.4-0.1-0.4-0.4c0-0.2,0.1-0.4,0.4-0.4h0.1h46.6 c0.2,0,0.4,0.2,0.4,0.4C-139.5-103.4-139.6-103.3-139.8-103.2z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_730_2_",
    transform: "translate(29.181 169.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_718_2_",
    transform: "translate(155.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_715_2_",
    transform: "translate(0 8.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1753_2_",
    className: "st13",
    d: "M-186.8-100.8c0.2,1.8,1,3.5,2.3,4.9c0.3,0.6,0.9,1,1.6,1.2 c0.2,0,0.5,0,0.7-0.2c0.1-0.1,0.2-0.3,0.3-0.5c0.6-1.6,0.7-3.3,0.2-4.9c-0.4-1.3-1.4-3.3-2.8-3.7 C-186.3-104.5-186.9-102.2-186.8-100.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_716_2_",
    transform: "translate(7.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1754_2_",
    className: "st14",
    d: "M-186-98.1c-0.5,2.5-0.8,5.1-0.8,7.7c-0.2,1.5,0,3,0.6,4.4 c0.2,0.5,0.7,0.8,1.2,0.9c0.4-0.1,0.8-0.3,1.1-0.6c1.7-1.8,2.8-4.1,3.3-6.6c0.4-2.4,0.6-4.9,0.6-7.4c0-1.5-0.2-4.7-2.6-4.2 C-184.6-103.5-185.5-99.8-186-98.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_717_2_",
    transform: "translate(3.379 4.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1755_2_",
    className: "st8",
    d: "M-183.1-80.9c-0.1,0-0.1,0-0.1-0.1l-3.6-12.6c0-0.1,0-0.2,0.1-0.2s0.2,0,0.2,0.1 l0,0l3.4,12l4.3-22.3c0-0.1,0.1-0.1,0.2-0.1s0.1,0.1,0.1,0.2l-4.4,22.9C-183-80.9-183-80.9-183.1-80.9L-183.1-80.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_729_2_",
    transform: "translate(0 27.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1764_2_",
    className: "st8",
    d: "M-12.2-103.7h-174.5c-0.1,0-0.1-0.1-0.1-0.1l0.1-0.1h174.5c0.1,0,0.1,0.1,0.1,0.1 S-12.1-103.7-12.2-103.7L-12.2-103.7z"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNuevaSolicitud);
export default __webpack_public_path__ + "static/media/image-nueva-solicitud.434a4687e14cf8a85a9d24565b6c6a93.svg";
export { ForwardRef as ReactComponent };